import React, { ReactElement, useEffect, useState } from 'react';
import './Example.scss';
import _ from 'lodash';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import ExampleImg from '../../assets/images/example.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

interface Props {
  exampleModalActive: boolean;
  setExampleModalActive: React.Dispatch<React.SetStateAction<boolean>>;
  userImage: string;
  userData: FormData;
}

const Example: React.FC<Props> = (props: Props): ReactElement => {
  const { t } = useTranslation();

  const getExample = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault(); // Let's stop this event.
    event.stopPropagation();
    try {
      await navigator.share({
        title: 'Meeldetuletus',
        text: 'Meeldetuletus',
        url: props.userImage,
      });
    } catch (err) {
      var link = document.createElement('a');
      link.download = 'meeldetuletus'; // <- name instead of 'name'
      link.href = props.userImage;
      link.click();
      link.remove();
    }
    // const res = await axios.post('localhost:3002/upload');
    // console.log(res);
    // const formData = props.userData;
    // formData.forEach((entries) => console.log(entries));
    // window.location.reload();

    // axios
    //   .post('http://192.168.1.81:3002/upload')
    //   //.post('http://192.168.1.81:3002/upload', {headers: {"Access-Control-Allow-Origin": "http://192.168.1.81:3002"}})
    //   .then((res) => {
    //     console.log(res.data);
    //   })
    //   .catch(function (error) {
    //     console.log(error);
    //   });
  };

  useEffect(() => {
    // getExample();
  }, []);

  return (
    <div
      id="example-modal"
      className={props.exampleModalActive ? 'modal is-active' : 'modal'}
    >
      {/* <div className="modal-background"></div> */}
      <div className="modal-content">
        <div className="columns">
          <div className="column title-col">
            <span>{t('preview')}</span>
          </div>
          <div className="column img-col">
            <img src={props.userImage} alt="" />
          </div>
          <div className="column close-col">
            <button
              className="modal-close-btn"
              aria-label="close"
              onClick={() =>
                props.setExampleModalActive(!props.exampleModalActive)
              }
            >
              <FontAwesomeIcon icon={faXmark} />
            </button>
          </div>
        </div>
        <div className="share-container">
          <div>
            <button className="button">{t('email')}</button>
            <button
              onClick={(e) => getExample(e)}
              className="button"
              // href={props.userImage}
              // download="meeldetuletus"
            >
              {t('download')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Example;
